export enum RegionalNamespaces {
  QUESTION_AND_RECOMMENDATIONS = "questionAndRecommendationTranslations",
  FEEDBACK_CARDS = "feedbackCardsTranslations",
}
